
import { usePlayerStore } from "@/stores/Player";
import type { ExposeInterface, StorageStreamProgress } from "./types";

export const useStorageStreamProgress = (): ExposeInterface => {
    const { playbackProgress } = usePlayerStore();
    const progressPositionKey = "progressPosition";

    const sendStreamProgressToApi = (): void => {
        const itemFromStorage = getProgressFromStorage();
        if (itemFromStorage) {
            void playbackProgress({ 
                id: itemFromStorage.id, type: itemFromStorage.type , progress: itemFromStorage.progress
            });
            deleteProgressFromStorage();
        }
    };

    const deleteProgressFromStorage = (): void => {
        localStorage.removeItem(progressPositionKey);
    };

    const getProgressFromStorage = (): StorageStreamProgress | null => {
        const item = localStorage.getItem(progressPositionKey);
        return item ? JSON.parse(item) : null;
    };

    const setProgressToStorage = (progressPosition: StorageStreamProgress): void => {
        localStorage.setItem(progressPositionKey, JSON.stringify(progressPosition));
    };

    return {
        sendStreamProgressToApi,
        deleteProgressFromStorage,
        setProgressToStorage,
        getProgressFromStorage
    };
}